/* ==========================================================================
   About Split Section — vanilla JS
   Zoom-on-hover applied via element.style.setProperty(prop, val, 'important')
   — an inline !important declaration, the strongest possible CSS override,
   so it works even if the shop's theme has global styles touching images.
   ========================================================================== */

(function () {
  'use strict';

  function initZoom(section) {
    var scalePercent = parseFloat(section.dataset.zoomScale) || 108;
    var scale = scalePercent / 100;
    var durationMs = parseInt(section.dataset.zoomDuration, 10) || 600;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var appliedScale = reduceMotion ? Math.min(scale, 1.02) : scale;
    var appliedDuration = reduceMotion ? 0 : durationMs;

    var media = section.querySelector('.about-split__media');
    var img = section.querySelector('.about-split__image');
    if (!media || !img) return;

    img.style.setProperty(
      'transition',
      'transform ' + appliedDuration + 'ms cubic-bezier(0.25, 0.7, 0.35, 1)',
      'important'
    );
    img.style.setProperty('transform-origin', 'center center', 'important');
    img.style.setProperty('transform', 'scale(1)', 'important');

    function zoomIn() {
      img.style.setProperty('transform', 'scale(' + appliedScale + ')', 'important');
    }
    function zoomOut() {
      img.style.setProperty('transform', 'scale(1)', 'important');
    }

    media.addEventListener('mouseenter', zoomIn);
    media.addEventListener('mouseleave', zoomOut);
    media.addEventListener('focusin', zoomIn);
    media.addEventListener('focusout', zoomOut);

    /* Touch devices: tap to toggle zoom */
    media.addEventListener(
      'touchstart',
      function () {
        var isZoomed = img.style.transform.indexOf('scale(' + appliedScale) !== -1;
        if (isZoomed) {
          zoomOut();
        } else {
          zoomIn();
        }
      },
      { passive: true }
    );
  }

  function initSection(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    initZoom(section);

    var enableAnimation = section.dataset.enableAnimation === 'true';
    if (!enableAnimation) return;

    section.classList.add('about-split--animate');

    if (!('IntersectionObserver' in window)) {
      section.classList.add('about-split--in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('about-split--in-view');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
  }

  function initAll() {
    document.querySelectorAll('[data-about-split]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-about-split]');
    if (section) {
      section.dataset.initialized = 'false';
      initSection(section);
    }
  });
})();